import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Youtube, Mail, MapPin, Phone } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const brands = [
  { name: 'TONYMOLY', url: 'https://tonymoly.mn/' },
  { name: 'Portmeirion', url: 'https://portmeirion.mn/' },
  { name: 'Ecover', url: 'http://www.ecovermongolia.mn/' }];


  const quickLinks = [
  { name: 'About Us', path: '/about' },
  { name: 'Our Brands', path: '/brands' },
  { name: 'Retail Presence', path: '/retail' },
  { name: 'Media', path: '/media' },
  { name: 'Contact', path: '/contact' }];


  return (
    <footer className="bg-black text-white border-t border-white/10">
      <div className="container mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-6 !bg-[rgba(209,17,17,0)]">
            <div className="flex items-center space-x-3">
              <img
                src="/images/amar-stars-logo-white.png"
                alt="Amar Stars LLC"
                className="h-16 w-auto" />
              <span className="text-xl font-semibold tracking-tight uppercase text-white" style={{ fontWeight: 600 }}>
                AMAR STARS
              </span>
            </div>

            <p className="text-sm text-gray-400 leading-relaxed font-light">
              Amar Stars LLC is a curator of global beauty, lifestyle, and wellness brands in Mongolia, delivering quality, design, and trusted brand experiences since 2010.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) =>
              <li key={link.path}>
                  <Link
                  to={link.path}
                  className="text-sm text-gray-400 hover:text-white transition-colors inline-block">

                    {link.name}
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Our Brands */}
          <div>
            <h3 className="text-lg font-bold mb-6">Our Brands</h3>
            <ul className="space-y-3">
              {brands.map((brand) =>
              <li key={brand.name}>
                  <a
                  href={brand.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-400 hover:text-white transition-colors inline-block">

                    {brand.name}
                  </a>
                </li>
              )}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3 text-sm text-gray-400">
                <MapPin size={18} className="mt-1 flex-shrink-0" />
                <div className="leading-relaxed">
                  KH Apartment - Amar Stars LLC<br />
                  1st Floor, KH Apartment<br />
                  East of Peace Bridge<br />
                  Khan-Uul District<br />
                  Ulaanbaatar, Mongolia
                </div>
              </li>
              <li className="flex items-start space-x-3 text-sm">
                <Phone size={18} className="mt-1 flex-shrink-0 text-gray-400" />
                <a href="tel:+97675008899" className="text-gray-400 hover:text-white transition-colors">
                  +976 7500 8899
                </a>
              </li>
              <li className="flex items-start space-x-3 text-sm">
                <Mail size={18} className="mt-1 flex-shrink-0 text-gray-400" />
                <a href="mailto:info@amarstars.com" className="text-gray-400 hover:text-white transition-colors">
                  info@amarstars.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © {currentYear} Amar Stars LLC. All rights reserved.
            </p>
            <p className="text-sm text-gray-400">
              Established Since 2010
            </p>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;